import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'address',
  standalone: true
})
export class AddressPipe implements PipeTransform {

  transform(value: any, city: any, state: any, zip: any, addtl_info:any): String {
    const address = addtl_info ? value + "\n" + city + ", " + state + "\n" + zip + "\n" + this.transform_helper(addtl_info) : value + "\n" + city + ", " + state + "\n" + zip
    return address;
  }

  transform_helper(addtl_info) {
    return addtl_info['title'] + "\n" + "Phone: " + addtl_info['phone'] + "\n" + "Fax: " + addtl_info['fax']
  }

}
